import React from "react";
import reactDom from "react-dom";
import App from "./App";
import ErrorBoundary from "./utility/ErrorBoundary";

const mount = (el) => {
  reactDom.render(
    // <ErrorBoundary>
    <App />,
    // </ErrorBoundary>,
    el,
  );
};

const rootElement = document.getElementById("root");
if (rootElement) {
  mount(rootElement);
}

export { mount, App };
